/**
 * 通用配置接口
 * @tutorial http://stage-math-op.vipkid-qa.com.cn/doc.html#/default/配置相关接口/addConfigUsingPOST
 */

import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

export const ConfigStatus = {
  /** 不生效 */
  Disabled: 0,
  /** 生效（数据可用） */
  Enabled: 1,
  /** 被禁用 */
  Banned: 2,
  /** 已删除 */
  Deleated: 3
}

/**
 * 添加配置
 * @param { object } data
 * @param { string } data.group - 组名
 * @param { string } data.key - 键名
 * @param { string } data.value - 键值
 * @param { ConfigStatus } data.status - 状态
 */
export function addConfig (data) {
  return request({
    url: `${parent}/api/config/add`,
    method: 'POST',
    data
  })
}

/**
 * 获取配置
 * @param { object } params
 * @param { string } params.group - 组名
 * @param { string } params.key - 键名
 */
export function getConfig (params) {
  return request({
    url: `${parent}/api/config/info`,
    method: 'GET',
    params
  })
}

/**
 * 更新配置
 * @param { object } data
 * @param { string } data.group - 组名
 * @param { string } data.key - 键名
 * @param { string } data.value - 键值
 * @param { ConfigStatus } data.status - 状态
 */
export function updateConfig (data) {
  return request({
    url: `${parent}/api/config/updateByKey`,
    method: 'POST',
    data
  })
}

/**
 * 保存配置
 * @description 数据不存在则新增，存在则更新
 * @param { object } data
 * @param { string } data.group - 组名
 * @param { string } data.key - 键名
 * @param { string } data.value - 键值
 * @param { ConfigStatus } data.status - 状态
 */
export function saveConfig (data) {
  return request({
    url: `${parent}/api/config/saveByKey`,
    method: 'POST',
    data
  })
}

/**
 * 批量更新配置
 * @param { object[] } data
 * @param { string } data[].group - 组名
 * @param { string } data[].key - 键名
 * @param { string } data[].value - 键值
 * @param { ConfigStatus } data[].status - 状态
 */
export function updateConfigBatch (data) {
  return request({
    url: `${parent}/api/config/updateByKey/batch`,
    method: 'POST',
    data
  })
}

/**
 * 批量保存配置
 * @param { object[] } data
 * @param { string } data[].group - 组名
 * @param { string } data[].key - 键名
 * @param { string } data[].value - 键值
 * @param { ConfigStatus } data[].status - 状态
 */
export function saveConfigBatch (data) {
  return request({
    url: `${parent}/api/config/saveByKey/batch`,
    method: 'POST',
    data
  })
}

/**
 * 根据组名获取配置列表
 * @param { object } params
 * @param { string } params.group - 组名
 */
export function getConfigListByGroup (params) {
  return request({
    url: `${parent}/api/config/list/group`,
    method: 'GET',
    params
  })
}
